import React from 'react'
import SaveExtra from '../../services/general/saveExtraData.api'

export const SaveActivity = async (updateValueString, type = 'Update') => {
    try {
        const exisitingActivityLogRowId = 6470
        console.log(updateValueString, 'updateValueString')
        let data = {
            masterActivity: {
                description: updateValueString,
                date: new Date().toISOString(),
            },
        }
        if (type === 'Update') {
            console.log('update running')
            await SaveExtra('Update', "activity_log", JSON.stringify(data), exisitingActivityLogRowId.toString())
        }
    }
    catch (e) {
        console.log(e, 'error')
    }
}

export const GetMasterActivityLog = async (mode = 'Get_By_Type', id = '6470') => {
    try {
    const result = await SaveExtra('Get_By_Type', 'activity_log', '', '')
        console.log(result,'resdatamasterac')
        return result
    } catch (error) {
        return error
    }
}